import React from 'react';
export const ThemeIcon = (props: any) => {
  return (
    <svg {...props} className="svg-icon__nav">
      <svg {...props} className="svg-icon">
        <svg id="icon-h-language" viewBox="0 0 22 22">
          <title>Select Language</title>
          <path
            d="M10.667,3.333 C10.667,3.333 5.347,-0.000 5.347,-0.000 C5.347,-0.000 0.000,3.338 0.000,3.338 C0.000,3.338 0.000,16.000 0.000,16.000 C0.000,16.000 5.333,12.667 5.333,12.667 C5.333,12.667 10.667,16.000 10.667,16.000 C10.667,16.000 16.000,12.667 16.000,12.667 C16.000,12.667 16.000,-0.000 16.000,-0.000 C16.000,-0.000 10.667,3.333 10.667,3.333 ZM1.333,13.594 C1.333,13.594 1.333,4.078 1.333,4.078 C1.333,4.078 4.667,1.997 4.667,1.997 C4.667,1.997 4.667,11.511 4.667,11.511 C4.667,11.511 4.627,11.536 4.627,11.536 C4.627,11.536 1.333,13.594 1.333,13.594 ZM6.000,11.511 C6.000,11.511 6.000,1.983 6.000,1.983 C6.000,1.983 9.959,4.463 9.959,4.463 C9.959,4.463 10.000,4.489 10.000,4.489 C10.000,4.489 10.000,14.011 10.000,14.011 C10.000,14.011 6.040,11.536 6.040,11.536 C6.040,11.536 6.000,11.511 6.000,11.511 ZM14.667,11.928 C14.667,11.928 11.333,14.011 11.333,14.011 C11.333,14.011 11.333,4.489 11.333,4.489 C11.333,4.489 11.373,4.464 11.373,4.464 C11.373,4.464 14.667,2.406 14.667,2.406 C14.667,2.406 14.667,11.928 14.667,11.928 Z"
            fillRule="evenodd"
          ></path>
        </svg>
      </svg>
    </svg>
  );
};
